import {
  saveRevokeData,
  getRevokeData,
  saveRollbackDataSingle,
} from "@/mixins/initRevokeData.js";
import {
  getEntityData,
  addEntityToDrawing,
  saveDatabaseStore,
} from "@/rlMxModules/operate/operateApi";
import store from "@/store";
import {
  resetAllRlLayer,
  getRlLayer,
  resetAllRlColSect,
  resetAllRlBeamSect,
  resetAllRlWallSect,
  resetAllRlSlabSect,
  getRlModules,
  getRlBeamSect,
  getRlWallSect,
  getRlColSect,
  getRlSlabSect,
  getRlRingBeamSect,
  getRlWallHoleDef,
  resetAllRlRingBeamSect,
  resetAllRlWallHoleDef,
  resetAllRlslabholedef,
  getRlslabholedef,
  resetAllRlCantiSlabDef,
} from "@/mixins/LiteModuleDb.js";

import {
  rlJointData,
  rlGridData,
  rlGridArcData,
  rlAxisData,
  rlAxisArcData,
  rlWallData,
  rlWallHoleData,
  rlColumnData,
  rlRingBeamData,
  rlSlabData,
  rlSlabHoleData,
  rlSubBeamData,
  rlBeamData,
  rlPartitionWallData,
  rlUseData,
  rlDoorsWindowsData,
  rlJointCData,
  rlAxisCData,
  rlGridCData,
  rlCantiSlabData,
} from "@/rlMxModules/rlDataClass/index";
import {
  showFullScreenLoading,
  tryHideFullScreenLoading,
} from "@/utils/loading";

let getData = null;

//从撤销数据中取出最后一次操作数据，然后将其添加到重做数据中
export const Re_Do = async (isRollback = false) => {
  showFullScreenLoading("撤销回退中...");
  try {
    getData = await getRevokeData(); //撤销数据

    let editData = null;
    let addData = null;
    let delData = null;
    let redoData = null;
    if (isRollback) {
      //判断回退数据是否大于一条，若没有，则无法回退
      if (!getData || getData.rollbackArr.length == 0) {
        return;
      }
      redoData = getData.rollbackArr.pop();

      if (!redoData) return;
      getData.revokeArr.push(redoData);
      editData = redoData.edit_after; //修改数据
      addData = redoData.delete; //新增数据
      delData = redoData.add; //删除数据
      //
    } else {
      //判断撤销数据是否大于一条，若没有，则无法撤销
      if (!getData || getData.revokeArr.length <= 1) {
        return;
      }
      redoData = getData.revokeArr.pop(); //取出最后一次操作数据

      if (!redoData) return;
      editData = redoData.edit_before; //修改数据
      addData = redoData.add; //新增数据
      delData = redoData.delete; //删除数据
    }

    //新增数据撤销
    await revokeAddData(addData);

    //删除数据撤销
    await revokeDeleteData(delData);

    // let modelColorData = {}; //记录构件颜色修改--用于同步撤销图层设置数据
    // let modelSectData = {}; //记录构件截面信息修改

    //修改数据撤销
    await revokeEditData(editData);

    // //判断构件颜色是否存在于设置中
    // if (modelColorData) {
    //   let isColorChange = false; //是否存在颜色修改
    //   //获取设置中的构件颜色
    //   let rlLayer = await getRlLayer();
    //   if (rlLayer) {
    //     for (let i = 0; i < modelColorData.length; i++) {
    //       const layer = modelColorData[i];
    //       if (
    //         modelColorData[layer.Type] &&
    //         modelColorData[layer.Type] != layer.Color
    //       ) {
    //         layer.Color = modelColorData[layer.Type];
    //         isColorChange = true;
    //       }
    //     }

    //     if (isColorChange) {
    //       await resetAllRlLayer(rlLayer);
    //     }
    //   }
    // }

    // //判断构件截面是否存在于截面列表中
    // if (modelSectData) {
    //   await changeModelSectData(modelSectData, "rlBeamSeg");
    //   await changeModelSectData(modelSectData, "rlColSeg");
    //   await changeModelSectData(modelSectData, "rlRingBeamSeg");
    //   await changeModelSectData(modelSectData, "rlSlabSeg");
    //   await changeModelSectData(modelSectData, "rlSubBeam");
    //   await changeModelSectData(modelSectData, "rlWallHole");
    //   await changeModelSectData(modelSectData, "rlWallSeg");
    //   await changeModelSectData(modelSectData, "rlSlabHole");
    // }

    // console.log(
    //   "新存储数据",
    //   getData,
    //   getData.revokeArr.length,
    //   getData.rollbackArr.length
    // );

    //将撤销/回退后数据保存
    await saveDatabaseStore();

    await saveRevokeData(getData); //将撤销数据保存到重做数据中

    //将撤销回退步数保存，用于修改撤销回退按钮的状态
    store.commit("globalData/setRevokeDataLength", getData.revokeArr.length);
    store.commit(
      "globalData/setRevokeRollbackLength",
      getData.rollbackArr.length
    );
    rlAppObj.rlMxDrawObject.updateDisplay();
    // if (!isRollback) {
    //   store.commit("globalData/addRawStep", "Revoke");
    // } else {
    //   store.commit("globalData/addRawStep", "Rollback");
    // }
    store.commit("globalData/SET_REDO", false);
    tryHideFullScreenLoading();
  } catch (error) {
    console.log("撤销回退失败", error);
    tryHideFullScreenLoading();
  } finally {
    tryHideFullScreenLoading();
  }
};

const revokeDeleteData = async (delData) => {
  if (delData && delData.length > 0) {
    //将删除数据还原
    //先整理数据--数据之间有依赖关系
    let dataGroup = {};
    for (let i = 0; i < delData.length; i++) {
      const item = delData[i];
      if (dataGroup[item.classTypeName]) {
        dataGroup[item.classTypeName].push(delData[i]);
      } else {
        dataGroup[item.classTypeName] = [];
        dataGroup[item.classTypeName].push(delData[i]);
      }
    }

    let jointData = {}; //记录新增节点数据
    if (dataGroup["rlJoint"]) {
      for (let i = 0; i < dataGroup["rlJoint"].length; i++) {
        const item = dataGroup["rlJoint"][i];
        let objTmp = new rlJointData();
        objTmp.reDraw(item);
        await addEntityToDrawing(objTmp, false);
        //

        jointData[item.Guid] = objTmp.Guid; //记录原始信息与新数据的对应关系
      }
    }

    let axisData = {};
    if (dataGroup["rlAxis"]) {
      for (let i = 0; i < dataGroup["rlAxis"].length; i++) {
        const item = dataGroup["rlAxis"][i];
        //判断数据是否需要更新
        item.m_stJoint = jointData[item.m_stJoint]
          ? jointData[item.m_stJoint]
          : item.m_stJoint;
        item.m_edJoint = jointData[item.m_edJoint]
          ? jointData[item.m_edJoint]
          : item.m_edJoint;
        let objTmp = null;
        if (item.IsMainAxis < 0) {
          objTmp = new rlAxisArcData();
        } else {
          objTmp = new rlAxisData();
        }
        objTmp.reDraw(item);
        await addEntityToDrawing(objTmp, false);
        axisData[item.Guid] = objTmp.Guid; //记录原始信息与新数据的对应关系
      }
    }

    let gridData = {};
    if (dataGroup["rlGrid"]) {
      for (let i = 0; i < dataGroup["rlGrid"].length; i++) {
        const item = dataGroup["rlGrid"][i];
        item.m_stJoint = jointData[item.m_stJoint]
          ? jointData[item.m_stJoint]
          : item.m_stJoint;
        item.m_edJoint = jointData[item.m_edJoint]
          ? jointData[item.m_edJoint]
          : item.m_edJoint;
        item.m_Axis = axisData[item.m_Axis]
          ? axisData[item.m_Axis]
          : item.m_Axis;

        let objTmp = null;
        if (item.m_centerJoint) {
          objTmp = new rlGridArcData();
        } else {
          objTmp = new rlGridData();
        }
        objTmp.reDraw(item);
        await addEntityToDrawing(objTmp, false);

        gridData[item.Guid] = objTmp.Guid; //记录原始信息与新数据的对应关系
      }
    }

    let jointDataC = {}; //记录新增节点数据--草图
    if (dataGroup["rlJointC"]) {
      for (let i = 0; i < dataGroup["rlJointC"].length; i++) {
        const item = dataGroup["rlJointC"][i];
        let objTmp = new rlJointCData();
        objTmp.reDraw(item);
        await addEntityToDrawing(objTmp, false);
        //

        jointDataC[item.Guid] = objTmp.Guid; //记录原始信息与新数据的对应关系
      }
    }

    //草图轴线数据
    let axisDataC = {};
    if (dataGroup["rlAxisC"]) {
      for (let i = 0; i < dataGroup["rlAxisC"].length; i++) {
        const item = dataGroup["rlAxisC"][i];
        //判断数据是否需要更新
        item.m_stJoint = jointDataC[item.m_stJoint]
          ? jointDataC[item.m_stJoint]
          : item.m_stJoint;
        item.m_edJoint = jointDataC[item.m_edJoint]
          ? jointDataC[item.m_edJoint]
          : item.m_edJoint;
        let objTmp = null;
        objTmp = new rlAxisCData();
        objTmp.reDraw(item);
        await addEntityToDrawing(objTmp, false);
        axisDataC[item.Guid] = objTmp.Guid; //记录原始信息与新数据的对应关系
      }
    }

    //草图网格数据
    let gridDataC = {};
    if (dataGroup["rlGridC"]) {
      for (let i = 0; i < dataGroup["rlGridC"].length; i++) {
        const item = dataGroup["rlGridC"][i];
        item.m_stJoint = jointDataC[item.m_stJoint]
          ? jointDataC[item.m_stJoint]
          : item.m_stJoint;
        item.m_edJoint = jointDataC[item.m_edJoint]
          ? jointDataC[item.m_edJoint]
          : item.m_edJoint;
        item.m_Axis = axisDataC[item.m_Axis]
          ? axisDataC[item.m_Axis]
          : item.m_Axis;

        let objTmp = null;
        objTmp = new rlGridCData();
        objTmp.reDraw(item);
        await addEntityToDrawing(objTmp, false);

        gridDataC[item.Guid] = objTmp.Guid; //记录原始信息与新数据的对应关系
      }
    }

    if (dataGroup["rlBeamSeg"]) {
      for (let i = 0; i < dataGroup["rlBeamSeg"].length; i++) {
        const item = dataGroup["rlBeamSeg"][i];
        let objTmp = new rlBeamData();
        if (gridData[item.m_gridData]) {
          item.m_gridData = gridData[item.m_gridData];
        }

        objTmp.reDraw(item);
        objTmp.draw();
        await addEntityToDrawing(objTmp, false);
        // item.objID = objTmp.objectId();
      }
    }

    if (dataGroup["rlColSeg"]) {
      for (let i = 0; i < dataGroup["rlColSeg"].length; i++) {
        const item = dataGroup["rlColSeg"][i];
        if (jointData[item.m_JointData]) {
          item.m_JointData = jointData[item.m_JointData];
        }

        let objTmp = new rlColumnData();
        objTmp.reDraw(item);
        objTmp.draw();
        await addEntityToDrawing(objTmp, false);
        // item.objID = objTmp.objectId();
      }
    }

    if (dataGroup["rlRingBeamSeg"]) {
      for (let i = 0; i < dataGroup["rlRingBeamSeg"].length; i++) {
        const item = dataGroup["rlRingBeamSeg"][i];
        if (gridData[item.m_gridData]) {
          item.m_gridData = gridData[item.m_gridData];
        }
        let objTmp = new rlRingBeamData();
        objTmp.reDraw(item);
        objTmp.draw();
        await addEntityToDrawing(objTmp, false);
        // item.objID = objTmp.objectId();
      }
    }
    if (dataGroup["rlSlab"]) {
      for (let i = 0; i < dataGroup["rlSlab"].length; i++) {
        const item = dataGroup["rlSlab"][i];
        let objTmp = new rlSlabData();
        objTmp.reDraw(item);
        objTmp.draw();
        await addEntityToDrawing(objTmp, false);
        // item.objID = objTmp.objectId();
      }
    }
    if (dataGroup["rlSlabHole"]) {
      for (let i = 0; i < dataGroup["rlSlabHole"].length; i++) {
        const item = dataGroup["rlSlabHole"][i];
        if (jointData[item.m_jointData]) {
          item.m_jointData = jointData[item.m_jointData];
        }
        let objTmp = new rlSlabHoleData();
        objTmp.reDraw(item);
        objTmp.draw();
        await addEntityToDrawing(objTmp, false);
        // item.objID = objTmp.objectId();
      }
    }
    if (dataGroup["rlSubBeam"]) {
      for (let i = 0; i < dataGroup["rlSubBeam"].length; i++) {
        const item = dataGroup["rlSubBeam"][i];
        let objTmp = new rlSubBeamData();
        objTmp.reDraw(item);
        objTmp.draw();
        await addEntityToDrawing(objTmp, false);
        // item.objID = objTmp.objectId();
      }
    }
    if (dataGroup["rlWallSeg"]) {
      for (let i = 0; i < dataGroup["rlWallSeg"].length; i++) {
        const item = dataGroup["rlWallSeg"][i];
        if (gridData[item.m_gridData]) {
          item.m_gridData = gridData[item.m_gridData];
        }
        let objTmp = new rlWallData();
        objTmp.reDraw(item);
        objTmp.draw();
        await addEntityToDrawing(objTmp, false);
        // item.objID = objTmp.objectId();
      }
    }

    if (dataGroup["rlPartitionWallSeg"]) {
      for (let i = 0; i < dataGroup["rlPartitionWallSeg"].length; i++) {
        const item = dataGroup["rlPartitionWallSeg"][i];
        let objTmp = new rlPartitionWallData();
        objTmp.reDraw(item);
        objTmp.draw();
        await addEntityToDrawing(objTmp, false);
        // item.objID = objTmp.objectId();
      }
    }
    if (dataGroup["rlWallHole"]) {
      for (let i = 0; i < dataGroup["rlWallHole"].length; i++) {
        const item = dataGroup["rlWallHole"][i];
        let objTmp = new rlWallHoleData();
        if (gridData[item.m_gridData]) {
          item.m_gridData = gridData[item.m_gridData];
        } else {
          let tempObj = getEntityData({
            Guid: item.m_gridData,
            classTypeName: "rlPartitionWallSeg",
          });
          if (tempObj) {
            item.m_gridData = tempObj.Guid;
          }
        }
        objTmp.reDraw(item);
        objTmp.draw();
        await addEntityToDrawing(objTmp, false);

        if (objTmp.m_gridData.classTypeName == "rlPartitionWallSeg") {
          objTmp.m_gridData.saveEditRevokeData();
          objTmp.m_gridData.m_HoleIdArray.push(objTmp.Guid);
          objTmp.m_gridData.updateThisObj(objTmp.m_gridData);
          objTmp.m_gridData.drawBreakWall();
          await saveDatabaseStore();
        } else if (objTmp.m_gridData) {
          if (objTmp.m_gridData.m_wallId) {
            const rlWAll = getEntityData({
              Guid: objTmp.m_gridData.m_wallId,
              classTypeName: "rlWallSeg",
            });
            if (rlWAll) {
              rlWAll.saveEditRevokeData();
              rlWAll.m_HoleId = objTmp.Guid;
              rlWAll.updateThisObj(rlWAll);
              rlWAll.drawBreakWall();
            }
          }
          await saveDatabaseStore();
        }
        // item.objID = objTmp.objectId();
      }
    }
    // if (dataGroup["rlDoorsWindows"]) {
    //   for (let i = 0; i < dataGroup["rlDoorsWindows"].length; i++) {
    //     const item = dataGroup["rlDoorsWindows"][i];
    //     let objTmp = new rlDoorsWindowsData();
    //     objTmp.reDraw(item);
    //     objTmp.draw();
    //     await addEntityToDrawing(objTmp, false);
    //     // item.objID = objTmp.objectId();
    //   }
    // }
    if (dataGroup["rlUse"]) {
      for (let i = 0; i < dataGroup["rlUse"].length; i++) {
        const item = dataGroup["rlUse"][i];
        let objTmp = new rlUseData();
        objTmp.reDraw(item);
        objTmp.draw();
        await addEntityToDrawing(objTmp, false);
        // item.objID = objTmp.objectId();
      }
    }
    if (dataGroup["rlCantiSlab"]) {
      for (let i = 0; i < dataGroup["rlCantiSlab"].length; i++) {
        const item = dataGroup["rlCantiSlab"][i];
        let objTmp = new rlCantiSlabData();
        objTmp.reDraw(item);
        objTmp.draw();
        await addEntityToDrawing(objTmp, false);
        // item.objID = objTmp.objectId();
      }
    }
    return { jointData, gridData, axisData, delData };
  }
};

const revokeAddData = async (addData) => {
  //判断是否有新增数据
  if (addData && addData.length > 0) {
    //草图的撤销回退
    if (store.state.globalData.isSketch) {
      //将删除数据还原
      //先整理数据--数据之间有依赖关系
      let dataGroup = {};
      let modelDataArray = [];
      for (let i = 0; i < addData.length; i++) {
        const item = addData[i];
        if (
          item.classTypeName == "rlGridC" ||
          item.classTypeName == "rlAxisC" ||
          item.classTypeName == "rlJointC"
        ) {
          if (dataGroup[item.classTypeName]) {
            dataGroup[item.classTypeName].push(addData[i]);
          } else {
            dataGroup[item.classTypeName] = [];
            dataGroup[item.classTypeName].push(addData[i]);
          }
        } else {
          modelDataArray.push(item);
        }
      }
      //先删除构件
      for (let i = 0; i < modelDataArray.length; i++) {
        const item = modelDataArray[i];
        const entityData = getEntityData({
          classTypeName: item.classTypeName,
          Guid: item.Guid,
        });

        if (entityData) {
          await entityData.erase();
        }
      }
      //再删除网格
      if (dataGroup["rlGridC"]) {
        for (let i = 0; i < dataGroup["rlGridC"].length; i++) {
          const item = dataGroup["rlGridC"][i];
          const entityData = getEntityData({
            classTypeName: item.classTypeName,
            Guid: item.Guid,
          });

          if (entityData) {
            await entityData.erase();
          }
        }
      }
      //再删除轴线
      if (dataGroup["rlAxisC"]) {
        for (let i = 0; i < dataGroup["rlAxisC"].length; i++) {
          const item = dataGroup["rlAxisC"][i];
          const entityData = getEntityData({
            classTypeName: item.classTypeName,
            Guid: item.Guid,
          });

          if (entityData) {
            await entityData.erase();
          }
        }
      }
      //再删除节点
      if (dataGroup["rlJointC"]) {
        for (let i = 0; i < dataGroup["rlJointC"].length; i++) {
          const item = dataGroup["rlJointC"][i];
          const entityData = getEntityData({
            classTypeName: item.classTypeName,
            Guid: item.Guid,
          });

          if (entityData) {
            await entityData.erase();
          }
        }
      }
    } else {
      //将删除数据还原
      //先整理数据--数据之间有依赖关系
      let dataGroup = {};
      let modelDataArray = [];
      for (let i = 0; i < addData.length; i++) {
        const item = addData[i];
        if (
          item.classTypeName == "rlGrid" ||
          item.classTypeName == "rlAxis" ||
          item.classTypeName == "rlJoint"
        ) {
          if (dataGroup[item.classTypeName]) {
            dataGroup[item.classTypeName].push(addData[i]);
          } else {
            dataGroup[item.classTypeName] = [];
            dataGroup[item.classTypeName].push(addData[i]);
          }
        } else {
          modelDataArray.push(item);
        }
      }
      //先删除构件
      for (let i = 0; i < modelDataArray.length; i++) {
        const item = modelDataArray[i];
        const entityData = getEntityData({
          classTypeName: item.classTypeName,
          Guid: item.Guid,
        });

        if (entityData) {
          await entityData.erase();
        }
      }
      //再删除网格
      if (dataGroup["rlGrid"]) {
        for (let i = 0; i < dataGroup["rlGrid"].length; i++) {
          const item = dataGroup["rlGrid"][i];
          const entityData = getEntityData({
            classTypeName: item.classTypeName,
            Guid: item.Guid,
          });

          if (entityData) {
            await entityData.erase();
          }
        }
      }
      //再删除轴线
      if (dataGroup["rlAxis"]) {
        for (let i = 0; i < dataGroup["rlAxis"].length; i++) {
          const item = dataGroup["rlAxis"][i];
          const entityData = getEntityData({
            classTypeName: item.classTypeName,
            Guid: item.Guid,
          });

          if (entityData) {
            await entityData.erase();
          }
        }
      }
      //再删除节点
      if (dataGroup["rlJoint"]) {
        for (let i = 0; i < dataGroup["rlJoint"].length; i++) {
          const item = dataGroup["rlJoint"][i];
          const entityData = getEntityData({
            classTypeName: item.classTypeName,
            Guid: item.Guid,
          });

          if (entityData) {
            await entityData.erase();
          }
        }
      }
    }
  }
};

const revokeEditData = async (editData) => {
  //判断是否有修改数据
  if (editData && editData.length > 0) {
    const typeGroup = {
      rlJoint: 1,
      rlJointC: 2,
      rlGrid: 3,
      rlGridC: 4,
      rlAxis: 5,
      rlAxisC: 6,
      rlBeamSeg: 7,
      rlColSeg: 8,
      rlRingBeamSeg: 9,
      rlSlab: 10,
      rlWallSeg: 11,
      rlPartitionWallSeg: 12,
      rlSlabHole: 13,
      rlWallHole: 14,
      rlUse: 15,
    };
    let dataGroup = {};
    for (let i = 0; i < editData.length; i++) {
      const item = editData[i];
      if (!typeGroup[item.classTypeName]) {
        console.log("item.classTypeName", item.classTypeName);

        continue;
      }
      if (dataGroup[typeGroup[item.classTypeName]]) {
        dataGroup[typeGroup[item.classTypeName]].push(editData[i]);
      } else {
        dataGroup[typeGroup[item.classTypeName]] = [];
        dataGroup[typeGroup[item.classTypeName]].push(editData[i]);
      }
    }

    //取出上一次操作中存在的所有数据
    for (const type of Object.keys(dataGroup)) {
      for (const item of dataGroup[type]) {
        const entityData = getEntityData({
          classTypeName: item.classTypeName,
          Guid: item.Guid,
        });

        if (entityData) {
          entityData.saveEditRevokeData();
          entityData.reDraw(item);
          entityData.updateThisObj(entityData);
        }
      }
    }
  }
};

const changeModelSectData = async (modelSectData, type) => {
  if (modelSectData[type] && modelSectData[type].length) {
    let currSectData = null;
    if (type == "rlBeamSeg" || type == "rlSubBeam") {
      await getRlBeamSect();
    } else if (type == "rlColSeg") {
      await getRlColSect();
    } else if (type == "rlRingBeamSeg") {
      await getRlRingBeamSect();
    } else if (type == "rlSlabSeg") {
      await getRlSlabSect();
    } else if (type == "rlWallHole") {
      await getRlWallHoleDef();
    } else if (type == "rlWallSeg") {
      await getRlWallSect();
    } else if (type == "rlSlabHole") {
      await getRlslabholedef();
    }

    let bChange = false;
    if (currSectData && currSectData.length) {
      for (let i = 0; i < currSectData.length; i++) {
        let item = currSectData[i];
        let findData = modelSectData[type].filter(
          (data) => data.Guid == item.Guid
        );
        if (findData && findData.length == 1) {
          currSectData[i] = findData[0];
          bChange = true;
        }
      }

      if (bChange) {
        await resetAllRlBeamSect(currSectData);
        if (type == "rlBeamSeg" || type == "rlSubBeam") {
          await resetAllRlBeamSect();
        } else if (type == "rlColSeg") {
          await resetAllRlColSect();
        } else if (type == "rlRingBeamSeg") {
          await resetAllRlRingBeamSect();
        } else if (type == "rlSlabSeg") {
          await resetAllRlSlabSect();
        } else if (type == "rlWallHole") {
          await resetAllRlWallHoleDef();
        } else if (type == "rlWallSeg") {
          await resetAllRlWallSect();
        } else if (type == "rlSlabHole") {
          await resetAllRlslabholedef();
        } else if (type == "rlCantiSlabDef") {
          await resetAllRlCantiSlabDef();
        }
      }
    }
  }
};
